
import Vue from "vue";
import {ProductBatchEditSellPricesBodyPrices} from "@/utils/products/product-batch-edit-sell-prices-body-prices";

export default Vue.extend({
	data(){
		return {
			toggle: false
		};
	},
	props: {
		value: {
			type: Object as ()=>ProductBatchEditSellPricesBodyPrices,
			required: true
		},
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
